import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { useSelector } from 'react-redux'

import Header from './components/header/Header';
import HomePageContainer from './pages/HomePageContainer';
import ShopHomePageContainer from './pages/ShopHomePageContainer';
import StepOne from './pages/steps/StepOne';
import StepTwo from './pages/steps/StepTwo';
import StepThree from './pages/steps/StepThree';
import StepFour from './pages/steps/StepFour';
import StepFive from './pages/steps/StepFive';
import StepSix from './pages/steps/StepSix';
import Thanks from './pages/Thanks';
import Error from './pages/Error';
import ErrorFullApp from './pages/ErrorFullApp';
import Note from './pages/Note';
import DataProtection from './pages/DataProtection';
import Footer from './components/footer/Footer';
import GoToTop from './components/go-to-top/GoToTop';
import ScrollToTop from './components/scroll-top/ScrollTop';
import ModalFaq from './components/static-modals/ModalFaq'
import FaqBtn from './components/faq-btn/FaqBtn';
import TagManager from 'react-gtm-module'
import Cookies from './components/cookies/Cookies';
import { withOneTabEnforcer } from "react-one-tab-enforcer"

function App( props ) {
    let endPage = useSelector( state => state.endPage );
    let productPrice     = useSelector(state => state.productPrice);
    let [ load, setLoad ] = useState(false);
    const tagManagerArgs = {
      gtmId: 'GTM-5563PBC'
    }
   
    TagManager.initialize(tagManagerArgs)

    // useEffect(() => {
    //     function closePage(ev) {
    //       ev.preventDefault();
    //       checkSameStorageValue()
    //       return ev.returnValue = 'Na pewno chcesz opuścić stronę? Wprowadzone zmiany mogą nie zostać zapisane';
    //     }
    //     if ( !endPage  ) {
    //       window.addEventListener("beforeunload", closePage );
    //     }
    //     return () =>  window.removeEventListener("beforeunload", closePage );
      
    // }, [ endPage ]) // Musi być włąćzone

    useEffect(() => {
      if ( !load ) {
          checkSessionStorage();
          setLoad(true)
      }
    }, [ load ])


    // set seesion storage: Prevent new tab
    let checkSameStorageValue = () => {
      // let local = window.localStorage.getItem("tabOpened");
      // let session = window.localStorage.getItem("tabOpened");
      // if (session == local) {
      //   window.localStorage.removeItem('tabOpened');
      //   window.sessionStorage.removeItem('tabOpened');

      //   window.localStorage.removeItem('tabDate');
      //   window.sessionStorage.removeItem('tabDate');
      // }
    }

    let setSessionStorage = (n) => {
      // window.sessionStorage.setItem('tabOpened', n);
      // window.localStorage.setItem('tabOpened', n);

      // let date = new Date().toLocaleString()
      // window.sessionStorage.setItem('tabDate', date);
      // window.localStorage.setItem('tabDate', date);
    }

    let checkSessionStorage = () => {
        // let local = window.localStorage.getItem("tabOpened");
        // let session = window.sessionStorage.getItem("tabOpened");
        // if ( !local ) {
        //     setSessionStorage(randomInteger(0, 1024));
        // } else {
        //   if ( local != session) {
        //     if ( window.location.pathname != '/error-sesja')
        //       window.location.href = '/error-sesja';
        //   }
        // }
    }

    let randomInteger = (min, max) => {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    // let Routes = () => {
    //   if ( productPrice < 10000.00 ) {
    //     return (
    //       <>
    //         <Route path="/krok/1" component={ StepOne } />
    //         <Route path="/krok/2" component={ StepTwo } />
    //         <Route path="/krok/3" component={ StepThree } />
    //         <Route path="/krok/4" component={ StepSix } />
    //       </>
    //     )
    //   } 
    //   else if( productPrice >= 10000.00 && productPrice < 30000.00) {
    //       return (
    //         <>
    //           <Route path="/krok/1" component={ StepOne } />
    //           <Route path="/krok/2" component={ StepTwo } />
    //           <Route path="/krok/3" component={ StepThree } />
    //           <Route path="/krok/4" component={ StepSix } />
    //         </>
    //       )
    //   } 
    //   else if( productPrice >= 30000.00) {
    //     return (
    //       <>
    //         <Route path="/krok/1" component={ StepOne } />
    //         <Route path="/krok/2" component={ StepTwo } />
    //         <Route path="/krok/3" component={ StepThree } />
    //         <Route path="/krok/4" component={ StepFour } />
    //         <Route path="/krok/5" component={ StepFive } />
    //         <Route path="/krok/6" component={ StepSix } />
    //       </> 
    //       )
    //   } 
    //   else {
    //     return (
    //       <>
    //         <Route path="/krok/1" component={ StepOne } />
    //         <Route path="/krok/2" component={ StepTwo } />
    //         <Route path="/krok/3" component={ StepThree } />
    //         <Route path="/krok/4" component={ StepFour } />
    //         <Route path="/krok/5" component={ StepFive } />
    //         <Route path="/krok/6" component={ StepSix } />
    //       </>
    //     )
    //   }
      
    // }
    let Routes = () => {
      return (
        <>
          <Route path="/krok/2" component={ StepOne } />
          <Route path="/krok/3" component={ StepTwo } />
          <Route path="/krok/4" component={ StepThree } />
          <Route path="/krok/5" component={ StepSix } />
        </>
      )
    }

    let checkCookie = () => {
      if (typeof window !== 'undefined') {
        if (localStorage.getItem('cookie') != null) {
          return false;
        } else {
          return true;
        }
      }
    }

    return (
    <div className="App">
      <div className="ghost" />
      <Router>
        <Header />
        <ScrollToTop>
            <Route path="/" exact component={ HomePageContainer } />
            <Route path="/kalkulacja/:key" component={ HomePageContainer } />
            <Route path="/sklep" component={ ShopHomePageContainer } />
            <Routes />
            <Route path="/dziekujemy" component={ Thanks } />
            <Route path="/nota-prawna" component={ Note } />
            {/* <Route path="/ochrona-danych" component={ DataProtection } /> */}
            {/* <Route path="/error-sesja" component={ Error } /> */}
            <Route path="/error-sesja" component={ ErrorFullApp } />
        </ScrollToTop>
        < GoToTop />
        <FaqBtn />
        <ModalFaq />
        <Cookies cookieText={`Ta strona wykorzystuje techniczne i funkcjonalne pliki cookies lub internetowe analityczne pliki cookies, za Twoją zgodą marketingowe pliki cookies. Więcej na ten temat przeczytasz w <a id='cookies-link' href="/od/?target=polityka-prywatnosci" target="__blank">Polityce prywatności</a>. Wchodząc na stronę wyrażasz na nie zgodę według ustawień Twojej przeglądarki. Możesz je w każdej chwili zmienić, a jeśli tego nie zrobisz przeglądanie strony nastąpi z wykorzystaniem tych plików.`} visible={ checkCookie() } />
        <Footer />
      </Router>
    </div>
    )
}

// export default App;
export default withOneTabEnforcer({appName: "grenke-calculator", OnlyOneTabComponent: ErrorFullApp})(App)
